import React, { useEffect, useState } from "react";
import isEmpty from "lodash.isempty";
import moment from "moment";

import Loading from "components/Loading";

import Context from "./Context";
import { useLiff } from "providers/Liff";
import { useToast } from "providers/Toast";
import { stage, expireTime, lineOAUrl, customerStatus } from "config/const";
import * as Client from "api/client";
import { isMobile } from "utils/method";

async function getClientProfiles(liff) {
  try {
    const profile = await liff.getProfile().catch((error) => {
      console.error(error);
      liff.logout();
      liff.login({ redirectUri: window.location.href });
      return false;
    });

    if (!profile) return { error: true };

    const profilePlus = liff.getDecodedIDToken() || {};
    const activityCustomerResp = await Client.getPrevActivityCustomerForm(
      profile.userId
    );
    if (!activityCustomerResp.err && !activityCustomerResp.error) {
      const {
        phone,
        firstName,
        lastName,
        name,
        birthday,
        email,
        fillinBranch,
        nameTitle,
      } = activityCustomerResp.data;
      profile.phone = phone;
      profile.firstName = firstName || name;
      profile.lastName = lastName;
      if (birthday) {
        const [year, month, day] = birthday.split("/");
        profile.year = year;
        profile.month = month;
        profile.day = day;
      }
      if (nameTitle) profile.gender = nameTitle;
      if (email) profile.email = email;
      if (fillinBranch) profile.branch = fillinBranch;
    } else {
      profile.phone = (profilePlus.phone_number || "").replace("+886", "0");
      profile.firstName = profile.displayName;
    }

    const userId = profile.userId;
    const accessToken = liff.getAccessToken();

    return { profile, accessToken, userId };
  } catch (error) {
    return { error };
  }
}

let refreshingClient = false;
const Provider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const [profile, setProfile] = useState({});
  const [userVerify, setUserVerify] = useState("");
  const [fetched, setFetched] = useState(false);
  const { liff, ready } = useLiff();
  const { danger } = useToast();

  const validAuth = auth.userId && auth.accessToken && !isEmpty(profile);

  const refreshClient = async () => {
    if (refreshingClient) return;
    refreshingClient = true;
    const { profile, accessToken, userId, error } = await getClientProfiles(
      liff
    );
    verifyClient(userId);

    refreshingClient = false;

    if (isEmpty(profile) || error) {
      danger("請登入後再試一次");
      return { err: true };
    }

    setProfile(profile);
    setAuth({ accessToken, userId });

    return { err: false };
  };

  const verifyClient = (userId) => {
    Client.verifyCoupon(userId).then((resp = {}) => {
      console.log(resp);
      if (resp && resp.status === 200) {
        setUserVerify(resp.data.status);
      } else if (resp.err && resp.message.status === 401) {
        setUserVerify(customerStatus.UNAUTHORIZED);
      }
      setFetched(true);
    });
  };

  // TODO: Activity modal should only open when the time end
  const isActivityEnd = moment(expireTime).endOf("day").isBefore(moment());

  useEffect(() => {
    console.log(liff, ready);
    if (!liff || !ready) return;

    if (stage !== "development" && !isMobile())
      return window.location.replace(lineOAUrl);

    if (stage !== "development" && !liff.isLoggedIn()) {
      return liff.login({ redirectUri: window.location.href });
    }
    refreshClient();
  }, [liff, ready]);

  const props = {
    auth,
    profile,
    validAuth,
    userVerify,
    isActivityEnd,
    fetched,
    verifyClient,
  };

  return (
    <Context.Provider value={{ ...props }}>
      {fetched ? children : <Loading />}
    </Context.Provider>
  );
};

export default Provider;
